import {Injectable, Injector, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {CustomerService} from "./customer.service";
import {NavService} from "./nav.service";
import {SettingsMenuItemType} from "../types/generated/settingsMenuItemType";

@Injectable({
  providedIn: 'root'
})
export class TitleService extends TitleStrategy {
  private readonly title: Title = inject(Title);
  private readonly injector: Injector = inject(Injector);
  private readonly customerService: CustomerService = inject(CustomerService);


  public updateTitle(routerState: RouterStateSnapshot): void {
    let title = 'HUMANSTARSapp';
    const customerName = this.customerService.customerResource()?.name ?? '';
    if (customerName) {
      title = customerName;
    }
    const requiredMenuType = this.getRequiredMenuType(routerState.root);
    const userMenuTitle = requiredMenuType ? this.resolveUserMenuTitle(requiredMenuType) : '';
    if (userMenuTitle) {
      title += ' - ' + userMenuTitle;
    }
    this.title.setTitle(title);
  }

  private getRequiredMenuType(route: ActivatedRouteSnapshot): SettingsMenuItemType | null {
    const requiredMenuType = route.data?.['requiredMenuType'] as SettingsMenuItemType | undefined;
    if (requiredMenuType) {
      return requiredMenuType;
    }

    for (const childRoute of route.children) {
      const childRequiredMenuType = this.getRequiredMenuType(childRoute);
      if (childRequiredMenuType) {
        return childRequiredMenuType;
      }
    }

    return null;
  }

  private resolveUserMenuTitle(requiredMenuType: SettingsMenuItemType): string {
    let navService: NavService;
    try {
      // Using injector here to prevent circular dependency injection
      navService = this.injector.get(NavService);
    } catch {
      return '';
    }

    return navService.userMenu().find((menuItem) => menuItem.type === requiredMenuType)?.name ?? '';
  }
}
